import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ddb8a336&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ddb8a336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8a336",
  null
  
)

export default component.exports